import { MotionConfig } from 'motion/react';
import type { ReactNode } from 'react';

/**
 * One global motion configuration. `reducedMotion="user"` makes Motion honour the
 * OS "reduce motion" setting everywhere automatically: transform-based animations
 * are skipped, opacity is kept, so content still appears — it just doesn't move.
 */
export function MotionProvider({ children }: { children: ReactNode }): JSX.Element {
  return <MotionConfig reducedMotion="user">{children}</MotionConfig>;
}
